<template>
  <div class="bw">
    <div class="outcard chatBlock" v-if="cu.cuid">
      <div class="chatBlockHeader">
        <h2>
          {{cu.nickname}} ({{cu.account}})
          <img
            v-if="!CuInBk"
            src="~assets/img/onlineblock/soundfilled001.png"
            class="bkIcon"
          />
          <img src="~assets/img/onlineblock/soundfilled002.png" class="inbk" v-if="CuInBk" />
        </h2>
        <div class="mt-10 mr-45 right">
          <button class="chbtn search" @click="search=true">
            <img src="~assets/img/public/searchlinear.png" style="transform:translateY(1px)" />
            搜尋
          </button>
          <ModalBlackUser :cu="cu" @getBlackList="getBlackList" />
        </div>
      </div>

      <div
        id="chatBlockbody" 
        :class="[dragOver ? 'dragevent' : '']"
        @drop.prevent="onDrop"
        @dragover="dragover"
        @dragleave.self="dragleave"
      >
        <div v-if="dragOver" class="drag">
          <div class="dragContent">
            <img src="~assets/img/onlineblock/Group 3153.png" />
            <p>拖曳上传图片</p>
            <p>(jpg, jpeg, png)</p>
          </div>
        </div> 
        <div class="cardin" id="chat_block">
          <div v-for="(item,idx) in dialog.chatlist">
            <div class="chatway" :key="idx" v-if="item.id != username.maid" :id="idx">
              <div class="left">
                <div class="chatwayblock">
                  <div class="name">
                    <p class="b">{{item.nickname}}</p>
                    <!-- 會員大圖預設圖 -->
                    <AvatarPic />
                  </div>
                  <div class="text">
                    <p class="t">{{item.time}}</p>
                    <div v-if="regex(item.innertext)" class="chatcloudl images">
                      <viewer>
                        <img :src="item.innertext" class="imgInInnertext" />
                      </viewer>
                    </div>
                    <div v-else class="chatcloudl">
                      <div v-if="searchval" v-html="replace(item.innertext)"></div>
                      <div v-else>
                        <p>{{item.innertext}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="chatway" :key="idx" v-if="item.id == username.maid" :id="idx">
              <div class="right">
                <div class="chatwayblock">
                  <div class="text tr">
                    <p class="t">{{item.time}}</p>
                    <div v-if="regex(item.innertext)" class="chatcloudl tr images">
                      <viewer>
                        <img :src="item.innertext" class="imgInInnertext" />
                      </viewer>
                    </div>
                    <div v-else class="chatcloudl tr">
                      <div v-if="searchval" v-html="replace(item.innertext)"></div>
                      <div v-else>
                        <p style="text-align:start">{{item.innertext}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="name tr">
                    <p class="b">{{item.nickname}}</p>
                    <!-- 客服大頭 -->
                    <AvatarPic :srcPic="username.image" style="position:absolute;right: 0" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cardin textarea">
          <Upload
            v-if="!CuInBk"
            name="img"
            action="/uploadImg"
            accept=".jpg, .jpeg, .png"
            :data="{ imgname: username.maid }"
            :format="['jpg','jpeg','png']"
            :before-upload="upImgBefore"
            :show-upload-list="false"
            style="display: inline-block"
          >
            <button class="stuffBtn upImgbtn mb-5">
              <span>
                <img src="~assets/img/public/photolinear.png" class="mr-5" />
              </span>上传图片
            </button>
          </Upload>
          <div v-if="dialog.imgUrl" class="preview mb-0">
            <div class="btg">
              <button class="previewbtn confirm" @click="upimg">上傳</button>
              <button class="previewbtn cancel" @click="cancelubimg">取消</button>
            </div>
          </div>
          <viewer :class="{viewer:!dialog.imgUrl}">
            <img :src="dialog.imgUrl" class="imgpreview" />
          </viewer>
          <Row>
            <Col :md="{ span : 18}" :xs="{ span : 15}">
              <div class="input-textarea">
                <Input
                  v-if="CuInBk"
                  type="textarea"
                  :autosize="{minRows: 4,maxRows: 7}"
                  placeholder="此用户再黑名单中 解除请至 客服设置→黑名单→解除黑名单"
                  disabled
                />
                <Input
                  v-else
                  type="textarea"
                  :autosize="{minRows: 4,maxRows: 7}"
                  placeholder="请填写讯息"
                  v-model="dialog.chatInnertext"
                  @keyup.enter.native="sendmsg"
                >
                  <img :src="dialog.imgUrl" />
                </Input>
              </div>
            </Col>
            <Col :md="{span:6}" :xs="{span:9}">
              <div class="gbtn" v-if="!CuInBk">
                <Row>
                  <Col :lg="{offset:2,span:6 }" :md="{offset:1,span:6 }">
                    <div class="btn btn-submit" @click="sendmsg">
                      <p>传送</p>
                    </div>
                  </Col>
                  <Col :lg="{span:6}">
                    <div class="btn btn-reset" @click="dialog.chatInnertext=''">
                      <p>重置</p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import chatBlockMixins from '../mixins/chatBlockMixins'
import { mapGetters } from 'vuex'
export default {
  name: "ChatBlock",
  mixins: [chatBlockMixins],
  components: {
    ModalBlackUser: () => import("./ModalBlackUser"),
  },
  props: {
    connect: {
      type: Boolean,
      required: true
    },
    bkDialog: Boolean,
    searchStatus: Boolean,
    cu: Object,
    searchval: String,
    qkText: String,
    chatlist: Array,
  },
  watch: {
    cu (cu) {
      this.cuInBlackList(cu.cuid)
      this.history()
    },
    qkText (val) {
      this.dialog.chatInnertext = val
    },
    'dialog.chatlist' (val) {
      this.$emit("update:chatlist", val)
    },
  },
  computed: {
    ...mapGetters(['username']),
    search: {
      get () {
        return this.searchStatus
      },
      set (val) {
        this.$emit("update:searchStatus", val)
      }
    }
  },
  methods: {
    //搜尋後chatlist改顏色
    replace (text) {
      let replaceString = '<span class="searchText">' + this.searchval + '</span>';
      return text.replace(this.searchval, replaceString)
    },
  }
}
</script>